import { render, staticRenderFns } from "./BookingNoGoBackBox.vue?vue&type=template&id=bb86fe08&scoped=true"
import script from "./BookingNoGoBackBox.vue?vue&type=script&lang=js"
export * from "./BookingNoGoBackBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb86fe08",
  null
  
)

export default component.exports